import { asyncTypes } from '../_helpers';

const types = {
  ...asyncTypes('FETCH_OPTIONS'),
  SET_DEFAULT_LIST: 'SET_DEFAULT_LIST'
};

export default types;
